exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-nav{padding:2em}.footer .nav-list:first-child .nav-item:first-child{border-top:none}.footer .nav-item{border:none;padding:.25em 0}.footer .nav-item-a{padding-right:1em;line-height:2}.footer .nav-item-a .fa{display:none}.footer .nav-sub-item{display:block;padding:.25em 0}.footer .nav-sub-item-a{padding-right:1em;line-height:2}.footer-info{padding:2em}.footer-copyright-p{text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/sass-loader/lib/loader.js!./src/components/footer/FooterCompany1/FooterCompany1.m.scss
// module id = 1243
// module chunks = 14